import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackSideMenuPrescriptionClick = (userId?: string): void => {
  trackingService.trackEvent(
    'PRESCRIPTION',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'side menu',
      surface: 'list',
      flow: 'prescrever',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSideMenuHistoryClick = (userId?: string): void => {
  trackingService.trackEvent(
    'HISTORY',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'side menu',
      surface: 'list',
      flow: 'histórico',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSideMenuProfileClick = (userId?: string): void => {
  trackingService.trackEvent(
    'PROFILE',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'side menu',
      surface: 'list',
      flow: 'perfil',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSideMenuAssistantClick = (userId?: string): void => {
  trackingService.trackEvent(
    'ASSISTANT',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'side menu',
      surface: 'list',
      flow: 'assistente',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSideMenuTutorialsClick = (userId?: string): void => {
  trackingService.trackEvent(
    'TUTORIALS',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'side menu',
      surface: 'list',
      flow: 'tutoriais',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSideMenuHelpClick = (userId?: string): void => {
  trackingService.trackEvent(
    'HELP',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'side menu',
      surface: 'list',
      flow: 'ajuda',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
